export class PageBuilderItem {
    CODE: PAGE_BUILDER_CODE_COMPONENT;
    LABEL?: string;
    INDEX?: number;
    ID?: string;
    BINDING?: string;
    SELECTED?: boolean;
    ITEMS?: PageBuilderItem[];
    PROPERTIES?: PageBuilderItem[];
    DEFAULT_VALUE?: any;
    IS_REQUIRED?: boolean;
    IS_READONLY?: boolean;
    IS_VISIBLE?: boolean;

    // COLUMN
    ORIENTATION?: string;
    ALIGNMENT?: string;

    // DROPDOWN
    DS_DATAS?: any[]
    DS_VALUE_COLUMN_NAME?: string;
    DS_DISPLAY_COLUMN_NAME?: string;

    // DATASOURCE
    DATASOURCES?: any[];

    // LABEL
    TEXT_STYLE?: string;

    // FORMAT
    TEXT_FORMAT?: string;

    // SEPARATOR
    SEPARATOR_STYLE?: string;
}

export enum PAGE_BUILDER_CODE_COMPONENT {
    ROW = 'ROW',
    COLUMN = 'COLUMN',
    LABEL = 'LABEL',
    TABLE = 'TABLE',
    BARCODE = 'BARCODE',
    QR_CODE = 'QRCODE',
    IMAGE = 'IMAGE',
    TEXTBOX = 'TEXTBOX',
    TEXTAREA = 'TEXTAREA',
    NUMERIC_TEXTBOX = 'NUMERIC_TEXTBOX',
    DROPDOWN = 'DROPDOWN',
    DATASOURCE_PICKER = 'DATASOURCE_PICKER',
    FILE_PICKER = 'FILE_PICKER',
    H_SEPARATOR = 'H_SEPARATOR',
    V_SEPARATOR = 'V_SEPARATOR',
}